import { useGetFeatureFlagsQueryOptions } from "@/api/config/config"
import type { GetFeatureFlagsResponse } from "@/api/model"
import ErrorReporter from "@/services/ErrorReporter"
import type { QueryClient } from "@tanstack/vue-query"

export const isFeatureFlagOn = async (
  queryClient: QueryClient,
  flag: keyof GetFeatureFlagsResponse,
): Promise<boolean> => {
  try {
    const flags = await queryClient.ensureQueryData(
      useGetFeatureFlagsQueryOptions(),
    )
    return flags[flag]
  } catch (error) {
    ErrorReporter.report(error)
    return false
  }
}
